<template>
    <v-tab-item>
        <resume-personal-information :value="resume" mode="view" />
        <resume-name :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-education :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-work-experience :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-hash-tags :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-languages :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-office-skills :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-certifications :value="resume" mode="view" class="mt-30 mt-lg-60" />
        <resume-cover-letter :value="resume" mode="view" class="mt-30 mt-lg-60" />
    </v-tab-item>
</template>

<script>
import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";

export default {
    components: {
        ResumeName,
        ResumeHashTags,
        ResumeEducation,
        ResumeLanguages,
        ResumeCoverLetter,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeWorkExperience,
        ResumePersonalInformation,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // resume
    },
    data: () => ({
        resume: undefined,
    }),
    mounted() {
        this.resume = this.formResume(this.value);
    },
    watch: {
        value() {
            this.resume = this.formResume(this.value);
        },
    },
    methods: {
        formResume(resume) {
            if (resume?.personalInformation?.bornAt) resume.personalInformation.bornAt = resume.personalInformation.bornAt.toDate();
            for (const item of resume?.education?.otherEducations || []) {
                item.tempId = Math.random();
            }
            for (const item of resume?.workExperience?.list || []) {
                item.tempId = Math.random();
                if (item?.duration?.startsAt) item.duration.startsAt = item.duration.startsAt.toDate();
                if (item?.duration?.endsAt) item.duration.endsAt = item.duration.endsAt.toDate();
            }
            return resume;
        },
    },
};
</script>

<style>
</style>